module.exports = __webpack_public_path__ + "videos/nft_explorer.adfce77.webm";